import React,{useState} from "react";
import { Link ,useHistory , useLocation} from 'react-router-dom';
import PageContainer from 'publish/layout/PageContainer';
import LayoutAside from "../../../layout/LayoutAside";
import UI from "components/UI";
import useToggleState from 'components/hooks/useToggleState';
import Button from 'components/buttons/';
import UIInput from 'components/input/input';
import CommonUtil from 'utils/CommonUtil';
import StringUtil from 'utils/StringUtil';
import BooleanUtil from 'utils/BooleanUtil';
import UIUtils from "utils/UIUtils";
import message from "common/message/source/MessageSource";
import codeDataStore from "common/codedata/store/CodeDataStore";
import UITextArea from "components/atoms/textarea/UITextArea";
function ContentsContainer() {

	const location = useLocation();
	const receivedData = (location.state as any)?.data;
  	const history = useHistory();
	const modaladm4211 = useToggleState({});
	const [authorInfo, setAuthorInfo] = useState({});
	const [authorCode,setAuthorCode] = useState('');
	const [authorNm,setAuthorNm] = useState('');
	const [useYn,setUseYn] = useState(false);
	const [useYnNm,setUseYnNm] = useState('');
	const [authorDc,setAuthorDc] = useState('');
	const [userAuthorYn,setUserAuthorYn] = useState(false);
	let [inputCount, setInputCount] = useState(0);



	//목롥으로 
	const goList = () =>{
		history.push({
			pathname: './adm6431',    //저장후 상세페이지로 이동
			state: { data: receivedData }
		});
	}

	//취소 상세페이지로 이동
	const authorDelete = function (){


		// 다른 페이지로 이동하면서 데이터 전달
		history.push({
			pathname: './adm6432',
			state: { data: receivedData }
		});
	}

	//권한 등록 저장
    async function authorSave(event) {
    	event.preventDefault();		
		if(authorCode == ""){
			UIUtils.alert("권한코드 입력은 필수입니다.").then()
			return;	
		}

		if(authorNm == ""){
			UIUtils.alert("권한이름 입력은 필수입니다.").then()
			return;	
		}

		console.log("AUTHOR_CODE : "+authorCode);
		console.log("AUTHOR_NM : "+authorNm);
		console.log("USE_YN : "+useYn);
		console.log("AUTHOR_DC : "+authorDc);
		console.log("USER_AUTHOR_YN : "+userAuthorYn);

		var paramUseYn ="";
		var paramUserAuthorYn ="";
		if(useYn){
			paramUseYn = "1"
		}else{
			paramUseYn = "0"
		}

		if(userAuthorYn){
			paramUserAuthorYn = "1"
		}else{
			paramUserAuthorYn = "0"
		}
		
		let param = {
			 AUTHOR_CODE:authorCode
			,AUTHOR_NM:authorNm
			,AUTHOR_DC:authorDc
			,USE_YN:paramUseYn
			,USER_AUTHOR_YN:paramUserAuthorYn
		}

		if(await UIUtils.confirm('저장하시겠습니까?')){
			
			const response:any = await CommonUtil.execute({
				url:"adm_6433_authorCreate",
				data: param
			})

			let vAUTHOR_ID= response.AUTHOR_ID;
			
			if (!response.COMMON_HEAD.ERROR) {
				await UIUtils.alert('저장되었습니다.');

			    let dataToSend = { vAUTHOR_ID }
				// 다른 페이지로 이동하면서 데이터 전달
				history.push({
				pathname: './adm6432',
				state: { data: dataToSend }
				});	
			}
		}
    };  


	//글자 수 체크 및 입력제한 
	const onTextareaHandler = (inputValue) => {
		// if(authorDc != ""){
		// 	inputValue = authorDc;
		// }
		if(inputCount == 4000){
           UIUtils.alert("4000자 이하로 입력해 주세요.").then();
		   return;
		}
			setInputCount(inputValue.replace(/[\0-\x7f]|([0-\u07ff]|(.))/g, "$&$1$2").length);
			setAuthorDc(inputValue);
	};

	React.useEffect(() => {
		//필요한 공통코드 로딩.
		codeDataStore.read("/common/yesNo", "/common/useYn");

		return () => {
		
		}
		
	}, [])//effect
              
	return (
		<PageContainer>
			<LayoutAside />
				<div className="fww-con">

					<ul className="fww-brd">
						<li className=""><a href="">홈</a></li>
						<li className=""><a href="">관리자페이지</a></li>
						<li className=""><a href="">시스템관리</a></li>
						<li className=""><a href="">권한관리</a></li>
					</ul>

					<main className="fww-main">
						<h1 className="tx tx-hd2">권한 등록</h1>
						<form className="fo fo-col3" name="" action="" method="">
							<div className="inner">
								<div className="fo-item req">
									<p className="fo-key">권한 코드</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'}  value={authorCode} valueChanged={(value) => setAuthorCode(value)} placeholder={''} />
									</div>
								</div>
								<div className="fo-item req">
									<p className="fo-key">권한 이름</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'}  value={authorNm} valueChanged={(value) => setAuthorNm(value)} placeholder={''} />
									</div>
								</div>
								<div className="fo-item req">
									<p className="fo-key">사용여부</p>
									<div className="fo-value">
										<div className="hz-root hz-gap15 h36">
											<UI.Radios
											value={BooleanUtil.toBoolean(useYn)}
											valueChanged={(value) => setUseYn(BooleanUtil.toBoolean(value))}
											codeData={codeDataStore.get("/common/useYn")}
											/>
										</div>
									</div>
								</div>
								
								<div className="fo-item fo-m-1-4">
									<p className="fo-key">권한 설명</p>
									<div className="fo-value">
										<div className="ta w100p">
											<UITextArea className={'ta-ip'}  value={authorDc} valueChanged={(value) => onTextareaHandler(value)} attrs={{ rows: 10 }}/>
											<div>
												<p className="tx tx-cp1 mt5">
													<em className="fc-err">{inputCount}</em> Bytes / 
													<em className="fc-err">4,000</em> Bytes
												</p>
											</div>
										</div>
										
									</div>
								</div>
								<div className="fo-item fo-m-1-4 req">
									<p className="fo-key">사용자별 권한관리 여부</p>
									<div className="fo-value">
										<div className="hz-root hz-gap15 h36">
											<UI.Radios
											value={BooleanUtil.toBoolean(userAuthorYn)}
											valueChanged={(value) => setUserAuthorYn(BooleanUtil.toBoolean(value))}
											codeData={codeDataStore.get("/common/yesNo")}
											/>
										</div>
									</div>
								</div>
							</div>
						</form>
						<div className="hz-root hz-right hz-gap5">
							<Button color="gray-o" size="sm" onClick={authorDelete}>삭제</Button>
							<Button color="pri-o" size="sm" onClick={authorSave}>저장</Button>
							<Button color='gray-o' size="sm" onClick={goList}>목록</Button>
						</div>
					</main>

				</div>
		</PageContainer>
	);
}
export default ContentsContainer;